import React from 'react';

const RpRevenue = React.lazy(() => import('pages/RpRevenue/RpRevenue'));

const RpRevenueRoutes = [
  {
    path: '/rp-revenue',
    exact: true,
    name: 'Báo cáo doanh thu',
    function: 'AM_BUSINESSTYPE_VIEW',
    component: RpRevenue,
  },
];

export default RpRevenueRoutes;
